<template>
    <div>
        <div>
            <b-form @submit="onSubmit"
                @reset="onReset"
                v-if="show">
                <div v-show="step === 1">
                    <h4 class="mt-5">
                        {{ this.steps[this.step-1] }}
                    </h4>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.name')"
                        id="inputOrganizationName"
                        required
                        class="my-5 inputField"
                        v-model="form.organizationName"
                        :state="!$v.form.organizationName.$dirty ? null : !$v.form.organizationName.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.street')"
                        id="inputStreet"
                        required
                        class="my-5 inputField"
                        v-model="form.street"
                        :state="!$v.form.street.$dirty ? null: !$v.form.street.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.zip-code')"
                        id="inputZipCode"
                        required
                        class="my-5 inputField"
                        v-model="form.zipCode"
                        :state="!$v.form.zipCode.$dirty ? null : !$v.form.zipCode.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.city')"
                        id="inputCity"
                        required
                        class="my-5 inputField"
                        v-model="form.city"
                        :state="!$v.form.city.$dirty ? null : !$v.form.city.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.state')"
                        id="inputState"
                        required
                        class="my-5 inputField"
                        v-model="form.state"
                        :state="!$v.form.state.$dirty ? null : !$v.form.state.$invalid"></b-form-input>
                    <div class="formNavButtons">
                        <b-button pill
                            class="formButton"
                            @click.prevent="next()">
                            {{ $t('actions.next') }}
                        </b-button>
                    </div>
                </div>
                <div v-show="step === 2">
                    <h4 class="mt-5">
                        {{ this.steps[this.step-1] }}
                    </h4>
                    <b-form-group class="my-5 leftTextAlign">
                        <b-form-input type="text"
                            :placeholder="$t('organizations.nipc')"
                            id="inputNipc"
                            required
                            class="inputField"
                            v-model="form.nipc"
                            :state="!$v.form.nipc.$dirty ? null : !$v.form.nipc.$invalid && !$v.form.nipc.$maxLength"></b-form-input>
                        <b-form-invalid-feedback id="inputNipc-feedback">
                            {{ $t('validations.max-length', {num: $v.form.nipc.$params.maxLength.max}) }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-input type="text"
                        :placeholder="$t('organizations.phone')"
                        id="inputOrganizationPhone"
                        required
                        class="my-5 inputField"
                        v-model="form.organizationPhone"
                        :state="!$v.form.organizationPhone.$dirty ? null : !$v.form.organizationPhone.$invalid"></b-form-input>
                    <b-form-input type="email"
                        :placeholder="$t('organizations.email')"
                        id="inputEmail"
                        required
                        class="my-5 inputField"
                        v-model="form.organizationEmail"
                        :state="!$v.form.organizationEmail.$dirty ? null : !$v.form.organizationEmail.$invalid"></b-form-input>
                    <b-form-group class="mb-0 my-5 leftTextAlign inputLabel"
                        :label="$t('organizations.select-time')"
                        label-for="inputPreferredDeliveryHour">
                        <b-form-input type="time"
                            id="inputPreferredDeliveryHour"
                            required
                            class="inputField"
                            v-model="form.deliveryHour"
                            :state="!$v.form.deliveryHour.$dirty ? null : !$v.form.deliveryHour.$invalid"></b-form-input>
                    </b-form-group>
                    <div class="formNavButtons">
                        <b-button pill
                            class="formButton"
                            @click.prevent="prev()">
                            {{ $t('actions.previous') }}
                        </b-button>
                        <b-button pill
                            class="formButton"
                            @click.prevent="next()">
                            {{ $t('actions.next') }}
                        </b-button>
                    </div>
                </div>
                <div v-show="step === 3">
                    <h4 class="mt-5">
                        {{ this.steps[this.step-1] }}
                    </h4>
                    <b-form-input type="text"
                        :placeholder="$t('users.first-name')"
                        id="inputFirstName"
                        required
                        class="my-5 inputField"
                        v-model="form.firstName"
                        :state="!$v.form.firstName.$dirty ? null : !$v.form.firstName.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('users.last-name')"
                        id="inputLastName"
                        required
                        class="my-5 inputField"
                        v-model="form.lastName"
                        :state="!$v.form.lastName.$dirty ? null : !$v.form.lastName.$invalid"></b-form-input>
                    <b-form-input type="text"
                        :placeholder="$t('users.phone')"
                        id="inputUserPhone"
                        required
                        class="my-5 inputField"
                        v-model="form.userPhone"
                        :state="!$v.form.userPhone.$dirty ? null : !$v.form.userPhone.$invalid"></b-form-input>
                    <b-form-input type="email"
                        :placeholder="$t('users.email')"
                        id="inputUserEmail"
                        required
                        class="my-5 inputField"
                        v-model="form.userEmail"
                        :state="!$v.form.userEmail.$dirty ? null : !$v.form.userEmail.$invalid"></b-form-input>
                    <b-form-group class="my-5 leftTextAlign">
                        <b-form-input type="password"
                            :placeholder="$t('users.password')"
                            id="inputPassword"
                            required
                            class="inputField"
                            v-model="form.password"
                            :state="!$v.form.password.$dirty ? null : !$v.form.password.$invalid && !$v.form.password.$minLength"></b-form-input>
                        <b-form-invalid-feedback id="inputPassword-feedback">
                            {{ $t('validations.min-length', {num: $v.form.password.$params.minLength.min}) }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <div class="formNavButtons">
                        <b-button pill
                            class="formButton"
                            @click.prevent="prev()">
                            {{ $t('actions.previous') }}
                        </b-button>
                        <b-button pill
                            class="formButton"
                            type="submit">
                            {{ $t('actions.register') }}
                        </b-button>
                    </div>
                </div>
            </b-form>
        </div>
        <b-progress :value="progressValue"
            :max="progressMaxValue"
            id="registrationProgressBar"
            height="20px">
            <b-progress-bar :value="progressValue">
                {{ steps[step-1] }}
            </b-progress-bar>
        </b-progress>

        <b-alert v-model="errored"
            variant="danger"
            dismissible>
            {{ errorMsg }}
        </b-alert>

        <b-alert v-model="success"
            variant="success"
            dismissible>
            {{ successMsg }}
        </b-alert>
    </div>
</template>

<script>
import organizationsService from '@/components/organizations/services/organizations'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'Registerform',

    data () {
        return {
            form: {
                organizationName: '',
                street: null,
                zipCode: null,
                city: null,
                state: null,
                nipc: null,
                organizationPhone: null,
                organizationEmail: null,
                deliveryHour: null,
                firstName: null,
                lastName: null,
                userPhone: null,
                userEmail: null,
                password: null
            },
            show: true,
            errorMsg: '',
            errored: false,
            successMsg: '',
            success: false,
            step: 1,
            maxSteps: 3,
            progressValue: 33,
            progressMaxValue: 100,
            steps: [
                this.$t('validations.register-step1'),
                this.$t('validations.register-step2'),
                this.$t('validations.register-step3')
            ]
        }
    },
    validations: {
        form: {
            organizationName: {
                required
            },
            street: {
                required
            },
            zipCode: {
                required
            },
            city: {
                required
            },
            state: {
                required
            },
            nipc: {
                required,
                maxLength: maxLength(12)
            },
            organizationPhone: {
                required
            },
            organizationEmail: {
                required,
                email
            },
            deliveryHour: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            },
            userPhone: {
                required
            },
            userEmail: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(8)
            }
        }
    },
    methods: {
        validateStep () {
            let valid = false

            switch (this.step) {
                case 1:
                    this.$v.form.organizationName.$touch()
                    this.$v.form.street.$touch()
                    this.$v.form.zipCode.$touch()
                    this.$v.form.city.$touch()
                    this.$v.form.state.$touch()

                    if (!(this.$v.form.organizationName.$invalid ||
                        this.$v.form.street.$invalid ||
                        this.$v.form.zipCode.$invalid ||
                        this.$v.form.city.$invalid ||
                        this.$v.form.state.$invalid)) {
                        valid = true
                    }
                    break
                case 2:
                    this.$v.form.nipc.$touch()
                    this.$v.form.organizationPhone.$touch()
                    this.$v.form.organizationEmail.$touch()
                    this.$v.form.deliveryHour.$touch()

                    if (!(this.$v.form.nipc.$invalid ||
                        this.$v.form.organizationPhone.$invalid ||
                        this.$v.form.organizationEmail.$invalid ||
                        this.$v.form.deliveryHour.$invalid)) {
                        valid = true
                    }
                    break
                case 3:
                    this.$v.form.firstName.$touch()
                    this.$v.form.lastName.$touch()
                    this.$v.form.userPhone.$touch()
                    this.$v.form.userEmail.$touch()
                    this.$v.form.password.$touch()

                    if (!(this.$v.form.firstName.$invalid ||
                        this.$v.form.lastName.$invalid ||
                        this.$v.form.userPhone.$invalid ||
                        this.$v.form.userEmail.$invalid ||
                        this.$v.form.password.$invalid)) {
                        valid = true
                    }
                    break
                default:
            }

            return valid
        },

        prev () {
            this.step--
            this.progressValue = this.step / this.maxSteps * 100
        },

        next () {
            if (this.validateStep()) {
                this.step++
                this.progressValue = this.step / this.maxSteps * 100
            }
        },

        makeDeliveryDateTime (deliveryDate, deliveryTime) {
            let year = deliveryDate.getFullYear()

            let month = deliveryDate.getMonth() + 1
            if (month < 10) {
                month = '0' + month
            }

            let day = deliveryDate.getDate()
            if (day < 10) {
                day = '0' + day
            }

            let deliveryHours = deliveryTime.split(':')[0]
            if (deliveryHours.length < 2) {
                deliveryHours = '0' + deliveryHours
            }

            let deliveryMinutes = deliveryTime.split(':')[1]
            if (deliveryMinutes.length < 2) {
                deliveryMinutes = '0' + deliveryMinutes
            }

            let deliveryDateTimeString = year + '-' + month + '-' + day + ' ' + deliveryHours + ':' + deliveryMinutes

            return deliveryDateTimeString
        },

        registerSuccessfull () {
            this.errored = false
            this.success = true
            this.successMsg = this.$t('validations.register-success')
        },

        registerFailed () {
            this.success = false
            this.errored = true
            this.errorMsg = this.$t('validations.register-fail')
        },

        async onSubmit (evt) {
            evt.preventDefault()
            let self = this

            if (!this.validateStep()) {
                return false
            }

            let params = {
                organizationName: self.form.organizationName,
                nipc: self.form.nipc,
                organizationPhone: self.form.organizationPhone,
                organizationEmail: self.form.organizationEmail,
                street: self.form.street,
                city: self.form.city,
                state: self.form.state,
                zip_code: self.form.zipCode,
                preferred_delivery_hour: this.makeDeliveryDateTime(new Date(), self.form.deliveryHour),
                firstName: self.form.firstName,
                lastName: self.form.lastName,
                userPhone: self.form.userPhone,
                userEmail: self.form.userEmail,
                password: self.form.password
            }

            let response = await organizationsService.createWithUser(params)

            if (response.data.organization_id) {
                self.registerSuccessfull()
            } else {
                self.registerFailed()
            }
        },

        onReset (evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.organizationName = ''
            this.form.street = null
            this.form.zipCode = null
            this.form.city = null
            this.form.state = null
            this.form.nipc = null
            this.form.organizationPhone = null
            this.form.organizationEmail = null
            this.form.deliveryHour = null
            this.form.firstName = null
            this.form.lastName = null
            this.form.userPhone = null
            this.form.userEmail = null
            this.form.password = null
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        }
    }
}
</script>
